// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"1a9bf4e7","952":"31315519"}[chunkId] + ".chunk.js";
};